import { DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import * as i6 from '@angular/router';
import { NavigationEnd, RouterModule } from '@angular/router';
import * as i2$1 from '@upr-web-primer/modal';
import * as i3$1 from '@upr-web-primer/simple-modal';
import * as i2 from '@upr-web-primer/storage';
import { StorageModule } from '@upr-web-primer/storage';
import { WINDOW, WindowModule } from '@upr-web-primer/window';
import { get, compact, isEmpty, merge, forEach, extend, map, includes, trimEnd, clone, find, join, findLast } from 'lodash-es';
import { throwError, Subscription, fromEvent, catchError as catchError$1 } from 'rxjs';
import { map as map$1, catchError, debounceTime, filter } from 'rxjs/operators';
import * as i4 from '@angular/common/http';
import * as i1 from '@upr-web-primer/browser-detector';
import * as i3 from '@upr-web-primer/locale';
import { LocaleModule } from '@upr-web-primer/locale';
import * as i7 from '@upr-web-primer/notification';
import moment from 'moment';
import * as i5 from 'ngx-cookie-service';
import { CookieService } from 'ngx-cookie-service';

class Analytics {
    static init(scriptSrc, scriptContent, removeExisting, async) {
        const analyticsTop = document.querySelector('script[class="analyticsTop"]');
        if (!removeExisting && analyticsTop) {
            if (analyticsTop.getAttribute('src') !== scriptSrc) {
                analyticsTop.setAttribute('src', scriptSrc);
            }
            this.injectScriptContent(scriptContent, removeExisting);
            window.dispatchEvent(new CustomEvent('AnalyticsScriptLoaded', { detail: false }));
            return;
        }
        if (analyticsTop) {
            analyticsTop.remove();
        }
        const scriptHeadTag = document.createElement('script');
        scriptHeadTag.setAttribute('src', scriptSrc);
        scriptHeadTag.setAttribute('class', 'analyticsTop');
        scriptHeadTag.async = !!async;
        document.head.appendChild(scriptHeadTag);
        scriptHeadTag.onload = () => {
            if (scriptContent) {
                this.injectScriptContent(scriptContent);
            }
            window.dispatchEvent(new CustomEvent('AnalyticsScriptLoaded', { detail: true }));
        };
    }
    static injectScriptContent(sciptContent, removeExisting) {
        const analyticsBottom = document.querySelector('script[class="analyticsBottom"]');
        if (analyticsBottom && removeExisting) {
            if (analyticsBottom.innerHTML !== sciptContent) {
                analyticsBottom.innerHTML = sciptContent;
            }
            return;
        }
        if (analyticsBottom) {
            analyticsBottom.remove();
        }
        const scriptBodyTag = document.createElement('script');
        scriptBodyTag.setAttribute('type', 'text/javascript');
        scriptBodyTag.setAttribute('class', 'analyticsBottom');
        scriptBodyTag.innerHTML = sciptContent;
        document.body.appendChild(scriptBodyTag);
    }
}

var AdultChild;
(function (AdultChild) {
    AdultChild["adult"] = "adult";
    AdultChild["child"] = "child";
    AdultChild["na"] = "N/A";
})(AdultChild || (AdultChild = {}));
var LinkEventAction;
(function (LinkEventAction) {
    LinkEventAction["Internal"] = "Internal Link";
    LinkEventAction["External"] = "External Link";
    LinkEventAction["Button"] = "Button";
})(LinkEventAction || (LinkEventAction = {}));
var CustomBoolean;
(function (CustomBoolean) {
    CustomBoolean[CustomBoolean["True"] = 1] = "True";
    CustomBoolean[CustomBoolean["False"] = 0] = "False";
})(CustomBoolean || (CustomBoolean = {}));
var CartEventType;
(function (CartEventType) {
    CartEventType["Add"] = "Add";
    CartEventType["Update"] = "Update";
    CartEventType["Remove"] = "Remove";
    CartEventType["View"] = "View";
    CartEventType["Upgrade"] = "Upgrade";
    CartEventType["Reset"] = "Reset";
    CartEventType["Modify"] = "Modify";
})(CartEventType || (CartEventType = {}));
var SearchEventKeyword;
(function (SearchEventKeyword) {
    SearchEventKeyword["SearchPrimaryCategory"] = "SearchPrimaryCategory";
    SearchEventKeyword["SearchSubCategory"] = "SearchSubCategory";
})(SearchEventKeyword || (SearchEventKeyword = {}));
var FormEventType;
(function (FormEventType) {
    FormEventType["Error"] = "Error";
    FormEventType["Success"] = "Submit";
    FormEventType["Warning"] = "Warning";
})(FormEventType || (FormEventType = {}));

class DigitalDataService {
    constructor(window, appDefaults, digitalDataPageConfigPath, browserDetection, localStorage, sessionStorage, localeService, httpClient, cookieService, route, notificationService) {
        this.window = window;
        this.appDefaults = appDefaults;
        this.digitalDataPageConfigPath = digitalDataPageConfigPath;
        this.browserDetection = browserDetection;
        this.localStorage = localStorage;
        this.sessionStorage = sessionStorage;
        this.localeService = localeService;
        this.httpClient = httpClient;
        this.cookieService = cookieService;
        this.route = route;
        this.notificationService = notificationService;
        this.defaultPage = {
            pageInfo: {},
            category: {},
            attributes: {},
        };
        this.digitalDataReferrer = {
            contentFocus: '',
            pageName: '',
        };
        this.internalReferrer = '';
        this.referringURL = '';
        this.isFirstCall = true;
        this.searchTermReferrer = [];
        this.ddlCreationDate = new Date().toISOString();
        const locale = this.localeService.getFromStorage();
        this.language =
            locale.language || get(this.appDefaults, 'DEFAULT_ROUTE_LANGUAGE', 'en');
        const country = locale.country || get(this.appDefaults, 'DEFAULT_ROUTE_COUNTRY', 'us');
        this.prefix = compact([this.language, country]).join('/');
        this.internalReferrer = this.window.document.referrer;
        this.searchTermReferrer = this.sessionStorage.getItem('searchTerms') || [];
        this.notifications$ = this.notificationService.notifications$.subscribe((data) => {
            if (data && get(data, 'show') && get(data, 'state') === 'error') {
                this.sessionStorage.setItem('USR_DSPLY_ERR_MSG', get(data, 'message') || '');
            }
        });
    }
    init() {
        if (this.window.digitalData) {
            this.digitalDataReferrer = {
                contentFocus: get(this.window.digitalData, 'page.attributes.contentFocus', ''),
                pageName: get(this.window.digitalData, 'page.pageInfo.pageName', ''),
            };
        }
        const defaultFunnel = {
            engage: CustomBoolean.True,
            intent: CustomBoolean.False,
            store: CustomBoolean.False,
            shop: CustomBoolean.False,
            buy: CustomBoolean.False,
        };
        this.window.digitalData = {
            pageInstanceID: '',
            page: {},
            optimization: {},
            platform: {},
            component: [],
            products: [],
            funnel: get(this.window.digitalData, 'funnel', defaultFunnel),
            user: {},
            transaction: {},
            cart: get(this.window.digitalData, 'cart', {}),
            events: get(this.window.digitalData, 'events', []),
            version: '1.0',
        };
        this.setPlatform();
        this.setUser();
        if (this.digitalDataPageConfigPath &&
            isEmpty(this.window.digitalDataPageConfig)) {
            this.getDigitalDataPageConfigPathResponse(this.digitalDataPageConfigPath);
        }
        else if (this.window.digitalDataPageConfig) {
            this.setPageData();
        }
    }
    setPage(page, override, setSubCategories) {
        if (!!override) {
            this.setPageGlobalValues(page);
            if (!!setSubCategories) {
                this.setSubCategoriesByUrl(page, true);
            }
        }
        this.window.digitalData.page = merge(this.window.digitalData.page, page || { pageInfo: {} });
        this.window.digitalData.pageInstanceID =
            page.pageInfo.pageID + '-' + page.pageInfo.sysEnv;
    }
    setPageGlobalValues(page) {
        if (!page.pageInfo) {
            page.pageInfo = {};
        }
        page.pageInfo.referringURL = this.referringURL.includes(this.window.document.location.origin)
            ? this.referringURL
            : this.window.document.referrer;
        page.pageInfo.sysEnv =
            this.appDefaults.DIGITAL_DATA_ENVIRONMENT ||
                (this.window.location.hostname.indexOf('www.') === 0 ? 'prod' : 'stage');
        page.pageInfo.destinationURL = this.window.document.location.href;
        page.pageInfo.language = this.language;
        page.pageInfo.version = page.pageInfo.version || '';
        page.pageInfo.author = page.pageInfo.author || '';
        page.pageInfo.issueDate = page.pageInfo.issueDate || '';
        page.pageInfo.effectiveDate = page.pageInfo.effectiveDate || '';
        page.pageInfo.expiryDate = page.pageInfo.expiryDate || '';
        page.pageInfo.geoRegion = page.pageInfo.geoRegion || '';
        page.pageInfo.industryCodes = page.pageInfo.industryCodes || [];
        page.pageInfo.publisher = page.pageInfo.publisher || '';
        page.pageInfo.onsiteSearchTerm = this.searchTermReferrer;
        page.attributes = this.setDefaultPageAttributes(page.attributes);
        return page;
    }
    setPageDefaults(page) {
        if (!page) {
            page = this.defaultPage;
        }
        page.pageInfo.pageName = get(this.digitalDataReferrer, 'pageName');
        page.category.subCategory1 = '';
        this.setSubCategoriesByUrl(page);
        this.setSearchEventCategory(SearchEventKeyword.SearchSubCategory, page.category.subCategory1);
        return page;
    }
    setSubCategoriesByUrl(page, ignorePageName) {
        page.category.subCategory1 = '';
        page.category.subCategory2 = '';
        page.category.subCategory3 = '';
        page.category.subCategory4 = '';
        const splitUrl = this.window.location.pathname.split(this.prefix + '/');
        if (splitUrl && splitUrl.length > 1 && !!splitUrl[1]) {
            const pageString = get(splitUrl, [1], '')
                .replace(/\/(index.html)/gi, '')
                .replace(/\//g, ' | ')
                .replace(/-/g, ' ')
                .replace('.html', '');
            const splitPageString = pageString && pageString.split('|');
            if (splitPageString && splitPageString.length > 1) {
                const defaultPageName = splitPageString
                    .slice(1)
                    .map((item) => {
                    return this.titleCase(item);
                })
                    .join(' | ');
                if (!ignorePageName) {
                    page.pageInfo.pageName = defaultPageName;
                }
                page.category.subCategory1 = this.titleCase(splitPageString[0] || '');
                page.category.subCategory2 = this.titleCase(splitPageString[1] || '');
                page.category.subCategory3 = this.titleCase(splitPageString[2] || '');
                page.category.subCategory4 = this.titleCase(splitPageString[3] || '');
            }
        }
    }
    updatePageQueryParameters(params) {
        if (get(this.window.digitalData.page, 'attributes')) {
            this.window.digitalData.page.attributes.queryParameters = params;
        }
        else {
            this.setDefaultPageAttributes();
        }
    }
    setDefaultPageAttributes(attributes) {
        if (!attributes) {
            attributes = {};
        }
        attributes.ddlCreationTimestamp = this.ddlCreationDate;
        const queryParams = this.route.queryParams;
        attributes.queryParameters = [];
        const queryParamArray = [];
        let querySubscription;
        if (queryParams) {
            querySubscription = queryParams.subscribe((params) => {
                forEach(params, (key, value) => {
                    queryParamArray.push({
                        key: value,
                        value: key,
                    });
                });
            });
        }
        attributes.queryParameters = queryParamArray;
        if (queryParams && querySubscription) {
            querySubscription.unsubscribe();
        }
        attributes.cleanURL =
            `${this.window.document.location.origin}${this.window.document.location.pathname}`.toLowerCase();
        attributes.destination = this.appDefaults.DIGITAL_DATA_DESTINATION || 'UPR';
        attributes.internalReferrer =
            this.internalReferrer || get(queryParams, '_value.intref', '');
        attributes.referrerContentFocus = get(this.digitalDataReferrer, 'contentFocus', '');
        attributes.referrerPageName = get(this.digitalDataReferrer, 'pageName', '');
        attributes.responsiveState = get(this.window.viewPortStatus, 'viewport', 'desktop');
        attributes.scrollPercent = this.getPageScrollPercentage();
        const hostName = get(this.window, 'document.location.hostname', '');
        const splitHost = hostName.split('.');
        const length = splitHost.length;
        const domain = `${splitHost[length - 2]}.${splitHost[length - 1]}`;
        attributes.domain = domain;
        attributes.subdomain = hostName.replace(`.${domain}`, '');
        attributes.attractionName = attributes.attractionName || '';
        attributes.businessObjective = attributes.businessObjective || '';
        attributes.queryParameters = attributes.queryParameters || [];
        attributes.contentFocus = attributes.contentFocus || '';
        attributes.tripAdvisorAggregateRating =
            attributes.tripAdvisorAggregateRating || '';
        attributes.tripAdvisorTotalRating = attributes.tripAdvisorTotalRating || '';
        return attributes;
    }
    setPageCategoryInstance(pageType, primaryCategory, anchorTag, subCategory1, subCategory2, subCategory3, subCategory4) {
        return {
            pageType,
            primaryCategory,
            anchorTag,
            subCategory1,
            subCategory2,
            subCategory3,
            subCategory4,
        };
    }
    setPageAttributes(businessObjective, contentFocus, attractionName = '', tripAdvisorAggregateRating = '', tripAdvisorTotalRating = '') {
        let pageAttributes = this.setDefaultPageAttributes();
        pageAttributes = extend(pageAttributes, {
            businessObjective,
            contentFocus,
            attractionName,
            tripAdvisorAggregateRating,
            tripAdvisorTotalRating,
        });
        return pageAttributes;
    }
    setProducts(products) {
        if (this.isDoNotTrack())
            return;
        this.window.digitalData.products = products;
    }
    setProduct(product) {
        if (this.isDoNotTrack())
            return;
        this.window.digitalData.products.push(product);
    }
    setComponents(components) {
        if (this.isDoNotTrack())
            return;
        this.window.digitalData.component = components;
    }
    setComponent(component) {
        if (this.isDoNotTrack())
            return;
        this.window.digitalData.component.push(component);
    }
    setOptimization(optimization) {
        if (this.isDoNotTrack())
            return;
        if (!isEmpty(optimization)) {
            this.window.digitalData.optimization = optimization;
        }
        else {
            this.window.digitalData.optimization = {
                campaign: [],
                testVariable: this.cookieService.get('uo-adobe-target_cookie') || '',
                targetVersion: get(this.window.adobe, 'target.VERSION', ''),
            };
            const interval = setInterval(() => {
                if (this.window.ttMETA === undefined) {
                    return;
                }
                clearInterval(interval);
                this.window.digitalData.optimization.campaign = map(this.window.ttMETA, (campaign) => {
                    const experienceName = get(campaign, 'experience', '');
                    const activityName = get(campaign, 'campaign', '');
                    return {
                        experienceName,
                        activityName,
                        activityExperienceName: `${activityName} ${experienceName}` || '',
                    };
                });
            }, 1000);
        }
    }
    setTransaction(transaction) {
        if (this.isDoNotTrack())
            return;
        this.window.digitalData.transaction = transaction;
    }
    setCart(cartID, price, attributes, item) {
        this.window.digitalData.cart = {
            cartID,
            price,
            attributes,
            item,
        };
    }
    setPlatform() {
        if (this.isDoNotTrack())
            return;
        const browserDetection = this.browserDetection.detect() || {};
        const digitalDataPlatformBrowser = {
            name: browserDetection.name,
            version: browserDetection.version,
            os: browserDetection.os,
        };
        this.window.digitalData.platform = {
            corporate: this.isCorporate() ? CustomBoolean.True : CustomBoolean.False,
            platformType: includes(['ios', 'android', 'ios-webview'], digitalDataPlatformBrowser.name)
                ? 'Mobile'
                : 'Desktop',
            platformBrowser: digitalDataPlatformBrowser,
            adBlocker: this.appDefaults.DIGITAL_DATA_AD_BLOCKER_ENABLED
                ? CustomBoolean.True
                : CustomBoolean.False,
            flashVersion: this.appDefaults.DIGITAL_DATA_FLASH_VERSION || '',
            sessionNumber: this.getSessionNumber(),
            userAgent: this.window.navigator.userAgent || '',
            version: [],
        };
        this.setDefaultPlatformVersions();
    }
    setPlatformVersion(technologyName, technologyVersion) {
        if (this.isDoNotTrack())
            return;
        this.window.digitalData.platform.version.push({
            technologyName,
            technologyVersion,
        });
    }
    setUser(user) {
        if (this.isDoNotTrack())
            return;
        const isLoggedIn = (this.localStorage.getItem('oAuthLogin') || '').toLowerCase() === 'true';
        const isReturnVisitor = (this.localStorage.getItem('returnVisitor') || '').toLowerCase() ===
            'true';
        const evSyncDD = this.getEvSyncDD();
        this.window.digitalData.user =
            user ||
                {
                    segment: this.appDefaults.DIGITAL_DATA_SEGMENT || 'B2C',
                    instanceID: this.localStorage.getItem('InteractGuestId') ||
                        this.localStorage.getItem('instance_id') ||
                        '',
                    age: '',
                    gender: '',
                    isAuthenticated: isLoggedIn ? CustomBoolean.True : CustomBoolean.False,
                    daysSinceLastVisit: evSyncDD,
                    geography: this.localStorage.getItem('USER_GEOGRAPHY') ||
                        this.cookieService.get('GEO_REGION_CODE') ||
                        '',
                    idAAM: this.cookieService.get('aam_uuid') || '',
                    idECMID: this.getEcmid(),
                    idGAID: this.cookieService.get('_gid') || '',
                    idGCLID: this.cookieService.get('_gcl_au') || '',
                    returning30Days: evSyncDD === 0
                        ? CustomBoolean.False
                        : evSyncDD <= 30
                            ? CustomBoolean.True
                            : CustomBoolean.False,
                    returning90Days: evSyncDD === 0
                        ? CustomBoolean.False
                        : evSyncDD <= 90
                            ? CustomBoolean.True
                            : CustomBoolean.False,
                    sessionPOO: {
                        country: this.cookieService.get('GEO_COUNTRY_CODE') || '',
                        region: this.cookieService.get('GEO_REGION_CODE') || '',
                        city: this.cookieService.get('GEO_CITY') || '',
                    },
                };
        const profileInfo = {
            profileID: this.localStorage.getItem('LOGGEDIN_GUEST_ID') || '',
            marketingId: this.localStorage.getItem('marketing_id') || '',
            language: this.localStorage.getItem('language') || this.language,
            returningStatus: isReturnVisitor ? 'Returning' : 'New',
            type: this.localStorage.getItem('USER_PROFILE_TYPE') || 'Consumer',
        };
        this.window.digitalData.user.profile = {
            profileInfo: profileInfo,
        };
    }
    setPageInfoSearchTerm(filterName, filterValue, filterType) {
        if (this.isDoNotTrack())
            return;
        if (!this.window.digitalData) {
            this.setPageData();
        }
        if (!this.window.digitalData.page) {
            this.window.digitalData.page = this.defaultPage;
        }
        this.searchTermReferrer.push({
            filterName,
            filterValue,
            filterType,
        });
        this.sessionStorage.setItem('searchTerms', this.searchTermReferrer);
        if (get(this.window, 'digitalData.page.pageInfo')) {
            this.window.digitalData.page.pageInfo.onsiteSearchTerm =
                this.searchTermReferrer;
        }
    }
    setPageInfoSearchResults(count) {
        if (this.isDoNotTrack())
            return;
        if (!this.window.digitalData) {
            this.setPageData();
        }
        if (!this.window.digitalData.page) {
            this.window.digitalData.page = this.defaultPage;
        }
        if (get(this.window, 'digitalData.page.pageInfo')) {
            this.window.digitalData.page.pageInfo.onsiteSearchResults = count;
        }
    }
    setSearchEventCategory(category, value) {
        if (this.window.location.href.includes('search-results')) {
            return;
        }
        this.sessionStorage.setItem(category, value);
    }
    getSearchEventCategory(category) {
        return this.sessionStorage.getItem(category) || '';
    }
    setAnalytics(scriptUrl, scriptContent, removeExisting, async) {
        const doNotTrack = this.sessionStorage.getItem('doNotTrack') === 'true';
        if (!doNotTrack)
            Analytics.init(scriptUrl, scriptContent, removeExisting, async);
    }
    setFunnelVariable(key, value) {
        if (this.isDoNotTrack())
            return;
        if (key && get(this.window.digitalData, 'funnel')) {
            this.window.digitalData.funnel[key] = value;
        }
    }
    getDigitalData() {
        return this.window.digitalData || {};
    }
    getPageInstance(pageInfo, category, attributes) {
        return {
            pageInfo,
            category,
            attributes,
        };
    }
    getPageInfoInstance(pageID, pageName, destinationURL, referringURL, sysEnv, variant, version, breadCrumbs, author = '', issueDate = '', effectiveDate = '', expiryDate = '', language = '', geoRegion = '', industryCodes = [''], publisher = '', onsiteSearchTerm = [], onsiteSearchResults = '') {
        return {
            pageID,
            pageName,
            destinationURL,
            referringURL,
            sysEnv,
            variant,
            version,
            breadCrumbs,
            author,
            issueDate,
            effectiveDate,
            expiryDate,
            language,
            geoRegion,
            industryCodes,
            publisher,
            onsiteSearchTerm,
            onsiteSearchResults,
        };
    }
    getProductInstance(productInfo, category, attributes) {
        return {
            productInfo,
            category,
            attributes,
        };
    }
    getProductExtendedInstance(productInfo, category, price, attributes) {
        return {
            productInfo,
            category,
            price,
            attributes,
        };
    }
    getProductInfoInstance(productID, productName, sku, plu, source, promo, manufacturer = '', description = '', productURL = '', productImage = '', productThumbnail = '') {
        return {
            productID,
            productName,
            sku,
            plu,
            source,
            promo,
            manufacturer,
            description,
            productURL,
            productImage,
            productThumbnail,
        };
    }
    getComponentInstance(componentInfo, category, attributes) {
        return { componentInfo, category, attributes };
    }
    getComponentInfoInstance(componentID, componentName, description) {
        return {
            componentID,
            componentName,
            description,
        };
    }
    getComponentCategoryInstance(primaryCategory, subCategory1, subCategory2) {
        return {
            primaryCategory,
            subCategory1,
            subCategory2,
        };
    }
    getComponentAttributesInstance(platformType, parentComponentID) {
        return {
            platformType,
            parentComponentID,
        };
    }
    getPricingSingleInstance(basePrice, currency, taxRate, shipping, shippingMethod, priceWithTax, voucherCode, voucherDiscount) {
        return {
            basePrice,
            currency,
            taxRate,
            shipping,
            shippingMethod,
            priceWithTax,
            voucherCode,
            voucherDiscount,
        };
    }
    getPricingInstance(basePrice, currency, taxRate, shipping, shippingMethod, priceWithTax, cartTotal, voucherCode, voucherDiscount) {
        return {
            basePrice,
            currency,
            taxRate,
            shipping,
            shippingMethod,
            priceWithTax,
            cartTotal,
            voucherCode,
            voucherDiscount,
        };
    }
    getEventInstance(eventInfo, category) {
        return { eventInfo, category };
    }
    getEventInfoInstance(eventName, eventAction, type, eventPoints, timeStamp, effect, eventTargetUrl = '') {
        return {
            eventName,
            eventAction,
            type,
            eventPoints,
            timeStamp,
            effect,
            eventTargetUrl,
        };
    }
    getEventCategoryInstance(primaryCategory, subCategory1) {
        return { primaryCategory, subCategory1 };
    }
    getEventCategoryData(subCategory) {
        return this.getEventCategoryInstance(get(this.getDigitalData(), 'page.category.primaryCategory', ''), subCategory ||
            get(this.getDigitalData(), 'page.category.subCategory1', ''));
    }
    setCategoryInstance(primaryCategory, subCategory1, subCategory2, subCategory3, subCategory4, componentType) {
        return {
            primaryCategory,
            subCategory1,
            subCategory2,
            subCategory3,
            subCategory4,
            componentType,
        };
    }
    setProductCategoryInstance(primaryCategory = '') {
        return {
            primaryCategory,
        };
    }
    getProductAttributesInstance(productAttributes, dateSelectedIn, dateSelectedOut, dateSelectedRange, packageID = '', packageInstanceID = '') {
        return {
            productAttributes,
            dateSelectedIn,
            dateSelectedOut,
            dateSelectedRange,
            packageID,
            packageInstanceID,
        };
    }
    getTransactionAttributesInstance(creditCardType, deliveryMethod, flowName, inMarket, numOfDaysToArrival, resortRooms, bookingEngine, totalGuests, paymentType) {
        return {
            creditCardType,
            deliveryMethod,
            flowName,
            inMarket,
            numOfDaysToArrival,
            resortRooms,
            bookingEngine,
            totalGuests,
            paymentType,
        };
    }
    getCartAttributesInstance(totalQty, totalViews, lastViewed) {
        return { totalQty, totalViews, lastViewed };
    }
    getScrollPercentage(elm) {
        if (!elm || !elm.parentNode) {
            return 0;
        }
        const parent = elm.parentNode;
        return (((elm.scrollTop || parent.scrollTop) /
            (parent.scrollHeight - parent.clientHeight)) *
            100);
    }
    getPageScrollPercentage() {
        const scrollPercent = Math.round(this.getScrollPercentage(this.window.document.body));
        return !scrollPercent ? '0' : scrollPercent.toString();
    }
    getJSON(path) {
        return this.httpClient.get(path).pipe(map$1((data) => {
            return data;
        }), catchError(this.handleError));
    }
    getProfileId() {
        return get(this.window.digitalData, 'user.profile.profileInfo.profileID', '');
    }
    getInstanceId() {
        return get(this.window.digitalData, 'user.instanceID', '');
    }
    logEvent(success, eventName, eventAction, eventEffect, eventType, btnData) {
        const targetUrl = get(btnData, 'href', '');
        let eventInfo;
        if (success) {
            eventInfo = this.getEventInfoInstance(eventName, eventAction, eventType, '', new Date().toISOString(), 'Success');
        }
        else {
            eventInfo = this.getEventInfoInstance(this.titleCase(eventName), this.titleCase(eventAction), eventType, '', new Date().toISOString(), eventEffect, targetUrl);
        }
        const eventCategory = this.getEventCategoryInstance(get(this.window, 'digitalData.page.category.primaryCategory', ''), get(this.window, 'digitalData.page.category.subCategory1', ''));
        const eventData = this.getEventInstance(eventInfo, eventCategory);
        this.fireEvent(eventData);
    }
    fireEvent(eventData) {
        if (!this.window.digitalData || !this.window.digitalData.events) {
            return;
        }
        this.window.digitalData.events.push(eventData);
        this.window.dispatchEvent(new CustomEvent('DigitalDataEvent', { detail: eventData }));
    }
    notifyFilterApplied(filterType, filterValue, category) {
        const eventInfo = this.getEventInfoInstance('Filter Applied', filterType, 'Filter', '', new Date().toISOString(), filterValue, '');
        const eventCategory = this.getEventCategoryData(category);
        const eventData = this.getEventInstance(eventInfo, eventCategory);
        this.fireEvent(eventData);
    }
    notifySearch(eventName, eventAction, eventEffect, category, eventPoints) {
        const eventInfo = this.getEventInfoInstance(this.titleCase(eventName), eventAction, 'Search', eventPoints || '', new Date().toISOString(), eventEffect, '');
        const eventCategory = this.getEventCategoryData(category);
        const eventData = this.getEventInstance(eventInfo, eventCategory);
        this.fireEvent(eventData);
    }
    notifyFormEvent(formName, message, type, category) {
        const eventInfo = this.getEventInfoInstance(this.titleCase(formName), type || FormEventType.Error, 'Form', '', new Date().toISOString(), message, '');
        const eventCategory = this.getEventCategoryData(category);
        const eventData = this.getEventInstance(eventInfo, eventCategory);
        this.fireEvent(eventData);
    }
    notifySystemErrorEvent(effect, type, category) {
        const eventInfo = this.getEventInfoInstance('System Error', 'Error', type || 'Page', '', new Date().toISOString(), effect, '');
        const eventCategory = this.getEventCategoryData(category);
        const eventData = this.getEventInstance(eventInfo, eventCategory);
        this.fireEvent(eventData);
    }
    notifyPageErrorEvent() {
        const eventInfo = this.getEventInfoInstance('Page Error', 'Error', 'Page', '', new Date().toISOString(), this.window.location.href, '');
        const eventCategory = this.getEventCategoryData();
        const eventData = this.getEventInstance(eventInfo, eventCategory);
        this.fireEvent(eventData);
    }
    notifyModalEvent(modalType, action, effect, category, type) {
        const eventInfo = this.getEventInfoInstance(this.titleCase(modalType), this.titleCase(action), type || 'Modal', '', new Date().toISOString(), effect, '');
        const eventCategory = this.getEventCategoryData(category);
        const eventData = this.getEventInstance(eventInfo, eventCategory);
        this.fireEvent(eventData);
    }
    notifyCartEvent(effect, cartEventType, category) {
        let eventInfo;
        switch (cartEventType) {
            case CartEventType.Add:
                eventInfo = this.getEventInfoInstance('Add To Cart', 'add', 'Cart', '', new Date().toISOString(), effect, '');
                break;
            case CartEventType.Update:
                eventInfo = this.getEventInfoInstance('Update To Cart', 'Update', 'Cart', '', new Date().toISOString(), effect, '');
                break;
            case CartEventType.Remove:
                eventInfo = this.getEventInfoInstance('Remove From Cart', 'Remove', 'Cart', '', new Date().toISOString(), effect, '');
                break;
            case CartEventType.View:
                eventInfo = this.getEventInfoInstance('View Cart', 'View', 'Cart', '', new Date().toISOString(), effect, '');
                break;
            case CartEventType.Upgrade:
                eventInfo = this.getEventInfoInstance('Upgrade Cart', 'Upgrade', 'Cart', '', new Date().toISOString(), effect, '');
                break;
            case CartEventType.Reset:
                eventInfo = this.getEventInfoInstance('Reset Cart', 'Reset', 'Cart', '', new Date().toISOString(), effect, '');
                break;
            case CartEventType.Modify:
                eventInfo = this.getEventInfoInstance('Modify Cart', 'Modify', 'Cart', '', new Date().toISOString(), effect, '');
                break;
            case CartEventType.Reset:
                eventInfo = this.getEventInfoInstance('Reset Cart', 'reset', 'Cart', '', new Date().toISOString(), effect, '');
                break;
            case CartEventType.Modify:
                eventInfo = this.getEventInfoInstance('Modify Cart', 'modify', 'Cart', '', new Date().toISOString(), effect, '');
                break;
        }
        if (!eventInfo) {
            return;
        }
        const eventCategory = this.getEventCategoryData(category);
        const eventData = this.getEventInstance(eventInfo, eventCategory);
        this.fireEvent(eventData);
    }
    getEventFromServerError(error, effect) {
        const savedEffect = effect || this.sessionStorage.getItem('USR_DSPLY_ERR_MSG');
        const errorStatus = get(error, 'status');
        const statusText = get(error, 'statusText');
        const errorDetails = `${error?.error?.detail}`;
        const systemError = `${errorStatus} ${statusText} ${errorDetails} | ${savedEffect || ''}`;
        const trimmedSystemError = trimEnd(systemError.trim(), '|').trim();
        const eventInfo = this.getEventInfoInstance('System Error', 'Error', 'Page', '', new Date().toISOString(), trimmedSystemError, get(error, 'url', ''));
        const eventCategory = this.getEventCategoryInstance(get(this.window.digitalData, 'page.category.primaryCategory', ''), get(this.window.digitalData, 'page.category.subCategory1', ''));
        return this.getEventInstance(eventInfo, eventCategory);
    }
    getEvSyncDD() {
        const lastVisited = this.localStorage.getItem('ev_sync_dd');
        if (!lastVisited) {
            this.localStorage.setItem('ev_sync_dd', moment(new Date()).format('YYYYMMDD'));
            return 0;
        }
        const lastVisitedDateTime = moment(lastVisited, 'YYYYMMDD');
        return moment().diff(lastVisitedDateTime, 'days');
    }
    handleError() {
        return throwError(new Error('Error on getting json file'));
    }
    setPageData() {
        const url = this.window.document.URL.toLowerCase();
        const pageConfig = this.window.digitalDataPageConfig;
        const page = clone(find(pageConfig, (item) => {
            const itemPattern = get(item, 'urlPattern');
            return itemPattern && new RegExp(itemPattern).test(url);
        }) || {});
        if (page && page['urlPattern']) {
            delete page['urlPattern'];
        }
        this.setPage(page, true, true);
    }
    setDefaultPlatformVersions() {
        this.window.digitalData.platform.version = [];
        this.window.digitalData.platform.version.push({
            technologyName: 'Tridion',
            technologyVersion: this.appDefaults.DIGITAL_DATA_TRIDION_VERSION,
        });
        this.window.digitalData.platform.version.push({
            technologyName: 'Application',
            technologyVersion: this.appDefaults.DIGITAL_DATA_APP_VERSION,
        });
        this.window.digitalData.platform.version.push({
            technologyName: 'Flash',
            technologyVersion: this.appDefaults.DIGITAL_DATA_FLASH_VERSION,
        });
        this.window.digitalData.platform.version.push({
            technologyName: 'Angular',
            technologyVersion: this.appDefaults.DIGITAL_DATA_ANGULAR_VERSION,
        });
    }
    isCorporate() {
        return false;
    }
    getDigitalDataPageConfigPathResponse(path) {
        return this.getJSON(path).subscribe((response) => {
            this.window.digitalDataPageConfig = get(response, 'pages', []);
            this.setPageData();
        }, (error) => {
            console.error('Failed to get digital data page config!', error);
        });
    }
    getEcmid() {
        const cookies = this.cookieService.getAll();
        const keys = Object.keys(cookies);
        const key = keys.find((cookie) => cookie.includes('AMCV_'));
        let value = '';
        if (key) {
            const splitted = this.cookieService.get(key).split('|');
            value = splitted.length >= 4 ? splitted[4] : value;
        }
        return (value ||
            this.cookieService.get('s_ecid') ||
            this.cookieService.get('s_vi') ||
            '');
    }
    getSessionNumber() {
        const check = this.sessionStorage.getItem('sessionStarted');
        let sessionNumber = Number(this.localStorage.getItem('sessionNumber')) || 0;
        if (!check) {
            this.localStorage.setItem('sessionNumber', ++sessionNumber);
            this.sessionStorage.setItem('sessionStarted', true);
        }
        return sessionNumber;
    }
    getCurrency() {
        return this.appDefaults.DEFAULT_CURRENCY_SYMBOL;
    }
    titleCase(str) {
        return str
            .trim()
            .toLowerCase()
            .split(' ')
            .map(function (word) {
            return word.replace(get(word, '0', ''), get(word, '0', '').toUpperCase());
        })
            .join(' ');
    }
    isDoNotTrack() {
        return this.sessionStorage.getItem('doNotTrack') === 'true';
    }
}
DigitalDataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DigitalDataService, deps: [{ token: WINDOW }, { token: 'AppDefaults' }, { token: 'DigitalDataPageConfigPath' }, { token: i1.BrowserDetectorService }, { token: i2.LocalStorageService }, { token: i2.SessionStorageService }, { token: i3.LocaleService }, { token: i4.HttpClient }, { token: i5.CookieService }, { token: i6.ActivatedRoute }, { token: i7.NotificationService }], target: i0.ɵɵFactoryTarget.Injectable });
DigitalDataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DigitalDataService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DigitalDataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['AppDefaults']
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['DigitalDataPageConfigPath']
                }] }, { type: i1.BrowserDetectorService }, { type: i2.LocalStorageService }, { type: i2.SessionStorageService }, { type: i3.LocaleService }, { type: i4.HttpClient }, { type: i5.CookieService }, { type: i6.ActivatedRoute }, { type: i7.NotificationService }]; } });

class AppDataLayerService {
    constructor(window, document, appDefaults, digitalDataService, appModalService, simpleModalService, sessionStorageService, zone, router) {
        this.window = window;
        this.document = document;
        this.appDefaults = appDefaults;
        this.digitalDataService = digitalDataService;
        this.appModalService = appModalService;
        this.simpleModalService = simpleModalService;
        this.sessionStorageService = sessionStorageService;
        this.zone = zone;
        this.router = router;
        this.events = {
            scroll: false,
            click: false,
            analyticsScript: false,
            pageData: false
        };
        this.firstLoad = true;
        this.subscriptions$ = new Subscription();
        this.digitalDataEnabled = get(this.appDefaults, 'DIGITAL_DATA_ENABLED', false);
        this.subscriptions$.add(this.appModalService.appModal$.subscribe(data => {
            if (get(data, 'status', false)) {
                const title = get(data, 'title', '');
                const templateTitle = get(data, 'componentTemplateTitle', '');
                this.modalDataLayer(title, templateTitle);
            }
        }));
        this.subscriptions$.add(this.simpleModalService.simpleModal$.subscribe(data => {
            if (data) {
                const title = get(data, 'data.Component.Folder.Title', '');
                const templateTitle = get(data, 'data.Component.Schema.Title', '').replace('K2', '');
                this.modalDataLayer(title, templateTitle);
            }
        }));
    }
    modalDataLayer(title, templateTitle) {
        const eventInfo = this.digitalDataService.getEventInfoInstance(title, 'Modal Message', 'Modal', '', new Date().toString(), templateTitle, this.window.document.URL);
        const eventCategory = this.digitalDataService.getEventCategoryInstance(get(this.window, 'digitalData.page.category.primaryCategory', ''), get(this.window, 'digitalData.page.category.subCategory1', ''));
        const eventData = this.digitalDataService.getEventInstance(eventInfo, eventCategory);
        this.digitalDataService.fireEvent(eventData);
    }
    initDigitalDataLayer(page) {
        const doNotTrack = this.sessionStorageService.getItem('doNotTrack') === 'true';
        if (this.digitalDataEnabled && !doNotTrack) {
            this.digitalDataService.init();
            if (!page) {
                this.digitalDataService.setFunnelVariable('intent', CustomBoolean.True);
                this.digitalDataService.setFunnelVariable('store', CustomBoolean.True);
                if (this.sessionStorageService.getItem('funnelShop') === '1') {
                    this.digitalDataService.setFunnelVariable('shop', CustomBoolean.True);
                }
            }
            if (this.firstLoad) {
                this.attachDataLayerEvents(!page);
            }
            if (page) {
                this.setDataLayer(page);
                if (!this.firstLoad) {
                    this.firePageLoadEvent();
                }
            }
            this.firstLoad = false;
        }
        else if (!this.appDefaults.ADOBE_TARGET_DISABLED &&
            this.appDefaults.ADOBE_HEADER_SCRIPT &&
            this.appDefaults.ADOBE_BODY_SCRIPT) {
            this.digitalDataService.setAnalytics(this.appDefaults.ADOBE_HEADER_SCRIPT, this.appDefaults.ADOBE_BODY_SCRIPT, this.appDefaults.ADOBE_HEADER_SCRIPT_RELOAD, this.appDefaults.ADOBE_HEADER_SCRIPT_ASYNC);
        }
    }
    setDataLayer(page) {
        this.setDataLayerForPage(page);
        this.setDataLayerForComponents(page);
    }
    setDataLayerForPage(page) {
        const pageData = this.digitalDataService.setPageDefaults();
        if (!pageData.pageInfo) {
            pageData.pageInfo = {};
        }
        pageData.pageInfo.pageName = get(page, 'MetadataFields.DigitaData.EmbeddedValues[0].pageName.Values[0]', pageData.pageInfo.pageName || '');
        pageData.pageInfo.pageID = get(page, 'MetadataFields.DigitaData.EmbeddedValues[0].pageID.Values[0]', pageData.pageInfo.pageName);
        if (!pageData.attributes) {
            pageData.attributes = {};
        }
        pageData.attributes.contentFocus = get(page, 'MetadataFields.DigitaData.EmbeddedValues[0].contentFocus.Values[0]', '');
        pageData.attributes.businessObjective = get(page, 'MetadataFields.DigitaData.EmbeddedValues[0].businessObjective.Values[0]', '');
        pageData.attributes.findingMethod = this.getPageFindingMethod();
        pageData.pageInfo.geoRegion = get(page, 'MetadataFields.DigitaData.EmbeddedValues[0].geoRegion.Values[0]', '');
        pageData.pageInfo.industryCodes = get(page, 'MetadataFields.DigitaData.EmbeddedValues[0].industryCodes.Values[0]', '');
        if (!pageData.category) {
            pageData.category = {};
        }
        pageData.category.primaryCategory = get(page, 'MetadataFields.DigitaData.EmbeddedValues[0].primaryCategory.Values[0]', '');
        this.digitalDataService.setSearchEventCategory(SearchEventKeyword.SearchPrimaryCategory, pageData.category.primaryCategory);
        pageData.category.pageType = get(page, 'MetadataFields.DigitaData.EmbeddedValues[0].pageType.Values[0]', '');
        let anchorTag = '';
        anchorTag = this.window.document.location.hash.replace('#', '');
        pageData.category.anchorTag = anchorTag;
        pageData.pageInfo.breadCrumbs = this.getBreadCrumbs();
        this.digitalDataService.setPage(pageData, true);
    }
    setAnchorTag(value) {
        if (!isEmpty(this.window.digitalData.page)) {
            this.window.digitalData.page.category.anchorTag = value;
        }
    }
    getComponentTitle(cp) {
        return (get(cp, 'Component.MetadataFields.contentId.Values[0]') ||
            get(cp, 'Component.Title', '') +
                ' ' +
                get(cp, 'ComponentTemplate.Title', ''));
    }
    setDataLayerForComponents(page, parentID = '') {
        const attributes = this.digitalDataService.getDigitalData().page.attributes;
        if (!parentID) {
            this.digitalDataService.setComponents([]);
        }
        forEach(page.ComponentPresentations, (cp) => {
            const component = {};
            component.componentInfo = this.digitalDataService.getComponentInfoInstance(this.getComponentTitle(cp), get(cp, 'Component.Title', ''), get(cp, 'ComponentTemplate.Title', ''));
            component.attributes = this.digitalDataService.getComponentAttributesInstance('Tridion', parentID);
            const componentSubCategoryInfo = this.getComponentSubCategoryInfo(get(cp, 'Component'));
            component.category = this.digitalDataService.getComponentCategoryInstance(get(cp, 'Component.Schema.Title') || get(cp, ''), componentSubCategoryInfo[0], componentSubCategoryInfo[1]);
            const componentTemplateTitle = get(cp.ComponentTemplate, 'Title');
            if (componentTemplateTitle ===
                'Heading - Page Title Bar Full Width - Angular') {
                attributes.attractionName =
                    cp.Component.Fields.PageTitle.Values[0].trim() || '';
            }
            this.digitalDataService.setComponent(component);
            let subComponents = !parentID && this.findLinkedComponent(cp);
            if (subComponents && subComponents.length) {
                subComponents = {
                    ComponentPresentations: subComponents
                };
                this.setDataLayerForComponents(subComponents, component.componentInfo.componentID);
            }
            const isAsset = !!get(cp, 'Component.MetadataFields.Details.EmbeddedValues[0].AttractionLocation.KeywordValues[0]') ||
                !!get(cp, 'Component.MetadataFields.Details.EmbeddedValues[0].AttractionExperience.KeywordValues[0]');
            if (isAsset) {
                this.updateDataLayerForPageAsset(cp.Component);
            }
        });
    }
    findLinkedComponent(presentation) {
        return (get(presentation, 'Component.Fields.Items.LinkedComponentValues') ||
            get(presentation, 'Component.Fields.items.LinkedComponentValues') ||
            get(presentation, 'Component.Fields.cards.LinkedComponentValues') ||
            get(presentation, 'Component.Fields.MobileBanners.LinkedComponentValues') ||
            get(presentation, 'Component.Fields.DesktopBanners.LinkedComponentValues') ||
            get(presentation, 'Component.Fields.BkgImage.LinkedComponentValues') ||
            get(presentation, 'Component.Fields.ImageOverlay.LinkedComponentValues') ||
            get(presentation, 'Component.Fields.AttractionExpAsset.EmbeddedValues.0.AssetDisplayed.LinkedComponentValues') ||
            get(presentation, 'Component.Fields.FlipLink.EmbeddedValues.Component.LinkedComponentValues') ||
            get(presentation, 'Component.Fields.ModalLink.LinkedComponentValues') ||
            get(presentation, 'Component.Fields.Image.EmbeddedValues.HighResolutionImage.LinkedComponentValues') ||
            get(presentation, 'Component.Fields.ModalLink.LinkedComponentValues', [])).map((comp) => {
            return { Component: comp };
        });
    }
    setDataLayerForFilterListComponents(tiles, parentID) {
        forEach(tiles, (tile) => {
            const component = {};
            const type = get(tile, 'Content.Heading')
                ? 'Filter List Component'
                : 'Filter List Component Promo';
            const title = get(tile, 'Content.Heading')
                ? get(tile, 'Content.Heading', '')
                : get(tile, 'Content.Title', '');
            component.componentInfo = this.digitalDataService.getComponentInfoInstance(title + ' - ' + type, title, type);
            component.attributes = this.digitalDataService.getComponentAttributesInstance('Tridion', parentID);
            component.category = this.digitalDataService.getComponentCategoryInstance(type, !type.includes('Promo') ? 'image' : 'text', !type.includes('Promo') ? 'jpg' : 'text');
            this.digitalDataService.setComponent(component);
        });
    }
    resetFilterListComponentList() {
        const filteredComponents = (this.window.digitalData.component || []).filter((cp) => !cp.componentInfo.componentID.includes('Filter List Component'));
        this.digitalDataService.setComponents(filteredComponents);
    }
    setBreadCrumbs(breadCrumbs) {
        if (breadCrumbs.length === 0) {
            return;
        }
        this.window.digitalData.page.pageInfo.breadCrumbs = breadCrumbs;
    }
    getPageFindingMethod() {
        return '';
    }
    getBreadCrumbs() {
        return [''];
    }
    getComponentSubCategoryInfo(content) {
        let subCategory = 'text';
        let subCategoryType = 'text';
        if (!isEmpty(content.Fields)) {
            forEach(content.Fields, (value, key) => {
                if (value && key && subCategory === 'text') {
                    const isVideo = key.toLowerCase().startsWith('video');
                    const isImage = key.toLowerCase().startsWith('image');
                    subCategory = isVideo ? 'video' : isImage ? 'image' : 'text';
                    if (isVideo && subCategoryType === 'text') {
                        const videoUrl = get(value, 'LinkedComponentValues[0].Multimedia.Url', '');
                        if (videoUrl.includes('.')) {
                            subCategoryType = get(videoUrl.split('.'), [1], subCategoryType);
                        }
                    }
                    else if (isImage && subCategoryType === 'text') {
                        const imgUrl = get(value, 'EmbeddedValues[0].HightResolutionIMage.LinkedComponentValues[0].Multimedia.Url', get(value, 'LinkedComponentValues[0].Multimedia.Url', ''));
                        if (imgUrl.includes('.')) {
                            subCategoryType = get(imgUrl.split('.'), [1], subCategoryType);
                        }
                    }
                }
            });
        }
        else if (get(content, 'Multimedia')) {
            const isImage = get(content, 'Multimedia.MimeType')
                .toLowerCase()
                .includes('image');
            subCategory = isImage ? 'image' : 'text';
            const imgUrl = get(content, 'Multimedia.Url', '');
            if (imgUrl.includes('.')) {
                subCategoryType = get(imgUrl.split('.'), [1], subCategoryType);
            }
        }
        return [subCategory, subCategoryType];
    }
    updateDataLayerForAnalytics() {
        this.digitalDataService.setOptimization();
        this.digitalDataService.setPlatformVersion('Adobe Target', get(this.window, 'adobe.target.VERSION', ''));
    }
    updateDataLayerForPageAsset(component) {
        const interests = get(component, 'MetadataFields.Details.EmbeddedValues[0].AttractionInterest.KeywordValues', []).map((interest) => get(interest, 'Key', ''));
        if (!isEmpty(interests)) {
            this.digitalDataService.setPageInfoSearchTerm('Attraction Interests', 'PageFilter', interests.join('|'));
        }
        const location = get(component, 'MetadataFields.Details.EmbeddedValues[0].AttractionLocation.KeywordValues', []).map((_location) => get(_location, 'Key', ''));
        if (!isEmpty(location)) {
            this.digitalDataService.setPageInfoSearchTerm('Attraction Locations', 'PageFilter', location.join('|'));
        }
    }
    attachDataLayerEvents(waitOnPageLoad) {
        this.routerEvents();
        if (!this.events.analyticsScript) {
            this.events.analyticsScript = true;
            this.subscriptions$.add(fromEvent(this.window, 'AnalyticsScriptLoaded').subscribe(() => this.analyticsLoadedHandler(waitOnPageLoad)));
        }
        if (!this.appDefaults.ADOBE_TARGET_DISABLED &&
            this.appDefaults.ADOBE_HEADER_SCRIPT &&
            this.appDefaults.ADOBE_BODY_SCRIPT) {
            this.digitalDataService.setAnalytics(this.appDefaults.ADOBE_HEADER_SCRIPT, this.appDefaults.ADOBE_BODY_SCRIPT, this.appDefaults.ADOBE_HEADER_SCRIPT_RELOAD, this.appDefaults.ADOBE_HEADER_SCRIPT_ASYNC);
        }
        else if (!waitOnPageLoad) {
            this.firePageLoadEvent();
        }
        this.attachLinkClickEvent();
        fromEvent(this.window, 'beforeunload').subscribe(() => {
            this.digitalDataService.getSessionNumber();
            this.sessionStorageService.removeItem('searchTerms');
        });
        if (waitOnPageLoad) {
            if (!this.events.pageData) {
                this.events.pageData = true;
                this.subscriptions$.add(fromEvent(this.window, 'PageDataLoaded').subscribe(() => this.pageDataLoadedHandler()));
            }
        }
    }
    firePageLoadEvent() {
        const eventInfo = this.digitalDataService.getEventInfoInstance(this.digitalDataService.titleCase(get(this.window.digitalData, 'page.pageInfo.pageName', '')), 'Load', 'Page', '', new Date().toISOString(), 'Page Loaded', '');
        const eventCategory = this.digitalDataService.getEventCategoryInstance(get(this.window.digitalData, 'page.category.primaryCategory', ''), get(this.window.digitalData, 'page.category.subCategory1', ''));
        const eventData = this.digitalDataService.getEventInstance(eventInfo, eventCategory);
        this.attachScrollEvent();
        this.digitalDataService.fireEvent(eventData);
        this.setAnchorTag((this.window.location.hash || '').replace('#', ''));
    }
    attachLinkClickEvent() {
        if (this.digitalDataEnabled && !this.events.click) {
            this.events.click = true;
            this.subscriptions$.add(fromEvent(this.document, 'click').subscribe((event) => {
                let targetNode = get(event, 'target');
                let targetNodeName = get(targetNode, 'nodeName', '').toLowerCase();
                const linkTypes = ['a', 'button'];
                if (!includes(linkTypes, targetNodeName)) {
                    targetNode = get(event, 'target.parentNode');
                    targetNodeName = get(targetNode, 'nodeName', '').toLowerCase();
                }
                const isCalendarButton = includes(get(targetNode, 'classList', []), 'calendar-day-btn');
                const ignoreDefaultEvent = get(targetNode, 'attributes.analytics-ignore-default-event.value', false)
                    .toString()
                    .toLowerCase() === 'true';
                if (!includes(linkTypes, targetNodeName) ||
                    isCalendarButton ||
                    ignoreDefaultEvent) {
                    return;
                }
                let linkName = get(targetNode, 'attributes.analytics.value') ||
                    get(targetNode, 'attributes.analytics-title.value') ||
                    get(targetNode, 'text') ||
                    get(targetNode, 'outerText') ||
                    get(targetNode, 'textContent', '');
                linkName = this.cleanString(linkName);
                const linkUrl = get(targetNode, 'href') ||
                    get(targetNode, 'attributes.analytics-href.value', '');
                const linkHost = get(targetNode, 'host', '');
                let linkTarget = LinkEventAction.Button;
                if (linkHost && linkUrl) {
                    linkTarget =
                        linkUrl.startsWith('/') ||
                            linkHost === this.document.location.host
                            ? LinkEventAction.Internal
                            : LinkEventAction.External;
                }
                const analyticsButtonType = get(targetNode, 'attributes.analytics-button-type.value', '');
                if (analyticsButtonType.toLowerCase() === 'modal' && !linkUrl) {
                    const analyticsModalType = get(targetNode, 'attributes.analytics-modal-type.value', '');
                    const analyticsModalAction = get(targetNode, 'attributes.analytics-modal-action.value', '');
                    const analyticsModalEffect = get(targetNode, 'attributes.analytics-modal-effect.value', '');
                    this.digitalDataService.notifyModalEvent(analyticsModalType || 'Modal', analyticsModalAction, analyticsModalEffect ||
                        this.customEventEffect(targetNode, linkName));
                }
                else {
                    const eventInfo = this.digitalDataService.getEventInfoInstance(this.digitalDataService.titleCase(linkName), linkTarget, 'Click', '', new Date().toISOString(), this.customEventEffect(targetNode, linkName), linkUrl);
                    const eventCategory = this.digitalDataService.getEventCategoryInstance(get(this.digitalDataService.getDigitalData(), 'page.category.primaryCategory', ''), get(this.digitalDataService.getDigitalData(), 'page.category.subCategory1', ''));
                    const eventData = this.digitalDataService.getEventInstance(eventInfo, eventCategory);
                    this.digitalDataService.fireEvent(eventData);
                    const anchortag = (this.window.location.hash || '').replace('#', '');
                    this.setAnchorTag(anchortag);
                }
            }));
        }
    }
    analyticsLoadedHandler(waitOnPageLoad) {
        this.updateDataLayerForAnalytics();
        if (!waitOnPageLoad) {
            this.firePageLoadEvent();
        }
    }
    pageDataLoadedHandler() {
        this.firePageLoadEvent();
    }
    attachScrollEvent() {
        if (this.digitalDataEnabled && !this.events.scroll) {
            this.events.scroll = true;
            this.subscriptions$.add(fromEvent(this.window, 'scroll')
                .pipe(debounceTime(200))
                .subscribe(() => {
                const attributes = get(this.digitalDataService.getDigitalData(), 'page.attributes');
                if (attributes && attributes.scrollPercent !== undefined) {
                    const scrollPercent = this.digitalDataService.getPageScrollPercentage();
                    if (!!scrollPercent) {
                        this.window.digitalData.page.attributes.scrollPercent = scrollPercent;
                    }
                }
            }));
        }
    }
    customEventEffect(ele, linkName) {
        try {
            const headElems = this.document.querySelectorAll('header a, header button');
            const footElems = this.document.querySelectorAll('footer a, footer button');
            const modlElems = this.document.querySelectorAll('upr-modal button, upr-modal a');
            let root = 'Body';
            let section = '';
            const effectArry = [];
            if (headElems && find(headElems, ele)) {
                root = 'Header';
                const sections = this.document.querySelectorAll('header section[class~=row]');
                const analyticsSectionName = get(ele, 'attributes.analytics-section-name.value', '');
                section =
                    (analyticsSectionName
                        ? analyticsSectionName
                        : this.getSectionTitle(sections, ele)) || 'Nav';
            }
            else if (footElems && find(footElems, ele)) {
                root = 'Footer';
                const sections = this.document.querySelectorAll('footer section[class~=row]');
                const analyticsSectionName = get(ele, 'attributes.analytics-section-name.value', '');
                section = analyticsSectionName
                    ? analyticsSectionName
                    : this.getSectionTitle(sections, ele, root);
            }
            else if (modlElems && find(modlElems, ele)) {
                root = 'Modal';
                section = this.getSectionTitle(this.document.querySelectorAll('upr-modal section[class~=row]'), ele);
            }
            else {
                const sections = this.document.querySelectorAll('main section[class~=row]');
                const analyticsSectionName = get(ele, 'attributes.analytics-section-name.value', '');
                section = analyticsSectionName
                    ? analyticsSectionName
                    : this.getSectionTitle(sections, ele);
            }
            effectArry.push(root);
            if (section) {
                effectArry.push('Section: ' + section);
            }
            effectArry.push('CTA: ' + linkName);
            return join(effectArry, ' | ');
        }
        catch {
            return linkName;
        }
    }
    getSectionTitle(target, ele, root = '') {
        const selectedSection = findLast(target, section => {
            return find(section.querySelectorAll('a, button'), ele);
        });
        const selectedParentName = get(selectedSection, 'parentElement');
        let sectionName = get(selectedParentName, 'tagName', '');
        if (sectionName === 'DIV' && root) {
            sectionName = get(selectedParentName, 'title', '');
        }
        return sectionName
            .replace('APP-', '')
            .replace('UPR-', '')
            .replace('-', ' ');
    }
    routerEvents() {
        this.subscriptions$.add(this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event) => {
            if (this.window.digitalData.page.attributes) {
                this.window.digitalData.page.attributes.internalReferrer =
                    this.digitalDataService.internalReferrer || '';
            }
            if (event instanceof NavigationEnd) {
                this.digitalDataService.internalReferrer = event.url;
                this.digitalDataService.referringURL = `${this.window.document.location.origin}${event.url}`;
            }
        }));
    }
    ngOnDestroy() {
        if (this.subscriptions$ && this.subscriptions$.unsubscribe) {
            this.subscriptions$.unsubscribe();
        }
    }
    cleanString(input) {
        return (input || '').replace(/<[^>]*>/g, '').trim();
    }
}
AppDataLayerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AppDataLayerService, deps: [{ token: WINDOW }, { token: DOCUMENT }, { token: 'AppDefaults' }, { token: DigitalDataService }, { token: i2$1.AppModalService }, { token: i3$1.SimpleModalService }, { token: i2.SessionStorageService }, { token: i0.NgZone }, { token: i6.Router }], target: i0.ɵɵFactoryTarget.Injectable });
AppDataLayerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AppDataLayerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AppDataLayerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['AppDefaults']
                }] }, { type: DigitalDataService }, { type: i2$1.AppModalService }, { type: i3$1.SimpleModalService }, { type: i2.SessionStorageService }, { type: i0.NgZone }, { type: i6.Router }]; } });

class DigitalDataModule {
}
DigitalDataModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DigitalDataModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DigitalDataModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DigitalDataModule, imports: [LocaleModule, StorageModule, WindowModule, RouterModule] });
DigitalDataModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DigitalDataModule, providers: [CookieService, DigitalDataService], imports: [[LocaleModule, StorageModule, WindowModule, RouterModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DigitalDataModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [LocaleModule, StorageModule, WindowModule, RouterModule],
                    providers: [CookieService, DigitalDataService]
                }]
        }] });

class SystemErrorInterceptor {
    constructor(window, digitalDataService, sessionStorageService) {
        this.window = window;
        this.digitalDataService = digitalDataService;
        this.sessionStorageService = sessionStorageService;
    }
    intercept(request, next) {
        return next.handle(request).pipe(catchError$1((error) => {
            setTimeout(() => {
                this.fireSystemErrorEvent(error);
            }, 100);
            throw error;
        }));
    }
    fireSystemErrorEvent(error) {
        const eventData = this.digitalDataService.getEventFromServerError(error);
        const errorStatus = get(error, 'status');
        if (includes(this.window.document.URL, 'web-store')) {
            if (new RegExp(/^(5[0-9]{2})$/g).test(errorStatus)) {
                this.digitalDataService.fireEvent(eventData);
            }
        }
        else {
            this.digitalDataService.fireEvent(eventData);
        }
        this.sessionStorageService.removeItem('USR_DSPLY_ERR_MSG');
    }
}
SystemErrorInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SystemErrorInterceptor, deps: [{ token: WINDOW }, { token: DigitalDataService }, { token: i2.SessionStorageService }], target: i0.ɵɵFactoryTarget.Injectable });
SystemErrorInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SystemErrorInterceptor, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SystemErrorInterceptor, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: DigitalDataService }, { type: i2.SessionStorageService }]; } });

export { AdultChild, Analytics, AppDataLayerService, CartEventType, CustomBoolean, DigitalDataModule, DigitalDataService, FormEventType, LinkEventAction, SearchEventKeyword, SystemErrorInterceptor };
